var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 80C34.0864 80 40 74.0267 40 66.6667V53.3333H26.8C19.5136 53.3333 13.6 59.3067 13.6 66.6667C13.6 74.0267 19.5136 80 26.8 80Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 40C13.6 32.64 19.5136 26.6667 26.8 26.6667H40V53.3333H26.8C19.5136 53.3333 13.6 47.36 13.6 40Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 13.3333C13.6 5.97333 19.5136 0 26.8 0H40V26.6667H26.8C19.5136 26.6667 13.6 20.6933 13.6 13.3333Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H53.2C60.4864 0 66.4 5.97333 66.4 13.3333C66.4 20.6933 60.4864 26.6667 53.2 26.6667H40V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4 40C66.4 47.36 60.4864 53.3333 53.2 53.3333C45.9136 53.3333 40 47.36 40 40C40 32.64 45.9136 26.6667 53.2 26.6667C60.4864 26.6667 66.4 32.64 66.4 40Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.c31b2179c2164ae24e7f387684162ba3.svg";
export { ForwardRef as ReactComponent };